import React, { Component, Fragment } from "react";
import { themeService } from "../../../../../../theme/service/activeTheme.service";
import ReportTableSectionRenderer from "../../../../../../libraries/ReportGenerator";
import { switchReportStyle } from "../../../../../Reports/sims/style";
import { trackReportStyle } from "../../../../../Reports/Timps/style";
import { iconCustomizer, iconToShow, iconTwoShow } from "../../../../../Reports/variables";
import SvgIcon from "react-icons-kit";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft";
import { printer } from "react-icons-kit/icomoon/printer";
import { languageService } from "../../../../../../Language/language.service";
import ImageArea from "../../../../../Common/ImageArea";
import { Col, Row } from "reactstrap";
import { getIssueMPMethods } from "../../../../../Common/services/mileposts";
import { LocPrefixService } from "../../../../../LocationPrefixEditor/LocationPrefixService";
import ExecutionReport from "./ExecutionReport";
import ReportInfoSection from "../../../../../../libraries/ReportGenerator/ReportInfoSection";
import TableHeader from "./TableHeader";
import { JourneyPlanHelper } from "../../../../../../utils/journeyPlanHelper";
import "./workOrderModal.css";
import ReportTitleSection from "../../../../../../libraries/ReportGenerator/ReportTitleSection";
import { versionInfo } from "../../../../../MainPage/VersionInfo";
export default class WorkOrderReport extends Component {
  render() {
    const { m1, maintenanceDetails } = this.props;
    let createdAtDate = m1.date ? m1.date : m1.createdAt ? m1.createdAt : null;
    const { issue, mrNumber, lineName, maintenanceType, bridge, chargeCode, afeNumber } = m1;
    const IssueImgList = issue ? issue.imgList : null;
    const closedBy = this.props.closedBy;
    let isLinear = issue.startMp && issue.endMp ? true : false;
    const assetId = issue && issue.unit && issue.unit.unitId;
    const startEnd = Methods.getMPS({}, m1);
    const isReVAMP = versionInfo.isReVAMP();
    const data = {
      assetId: assetId || null,
      mrNumber: mrNumber,
      mp: isLinear ? `${startEnd.startMp} - ${startEnd.endMp}` : startEnd.startMp,
      maintenanceType: maintenanceType,
      chargeCode: chargeCode,
      afeNumber: afeNumber,
      ...(bridge ? bridge : {}),
    };
    const includeBridgeFields = bridge && Object.keys(bridge).length > 0 ? true : false;
    return (
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <div className="wo-pageBreak-avoid">
          <ReportTitleSection title={languageService("Work Order Summary Report")} fontSizeOverride={"35px"} showSecondLogo={true} />
          <span className="spacer"></span>
          <span className="spacer"></span>
          <div className="wor_reportTitle">
            <p style={{ fontSize: "x-large", fontWeight: 700 }}>
              {languageService(isReVAMP ? "" : languageService("Work Order Information"))}
            </p>
            <p className="wor_mrNumber">
              <p>{mrNumber}</p>
            </p>
          </div>
          <span className="spacer"></span>
          <TableHeader data={data} includeBridgeFields={includeBridgeFields} />

          {m1.status === "Complete" && (
            <ReportInfoSection
              fontSizeOverride={"16px"}
              rows={[
                {
                  col1: {
                    title: languageService("Closed By"),
                    value: closedBy ? closedBy : JourneyPlanHelper.getMaintenanceClosedBy(maintenanceDetails),
                  },
                  col2: {
                    title: languageService("Close Date"),
                    value: Methods.getCloseDate(maintenanceDetails),
                  },
                },
              ]}
            />
          )}
          <ReportInfoSection
            fontSizeOverride={"16px"}
            rows={[
              {
                col1: {
                  title: languageService("Status"),
                  value: m1.status,
                },
                ...(m1.status &&
                  ["New", "Planned"].includes(m1.status) &&
                  createdAtDate && {
                    col2: { title: languageService("Created Date"), value: Methods.convertDateToFormat(createdAtDate) },
                  }),
              },
            ]}
          />
          <span className="spacer"></span>
          <div>
            <strong>{languageService("Information")}:</strong>
            <div style={{ border: "1px solid black", width: "100%", minHeight: "50px", padding: "10px" }}>
              <p>{issue.voiceNotes}</p>
              {issue.comments && (
                <p>
                  <strong>{languageService("Maintainer Comments:")}</strong>
                  {issue.reportComments}
                </p>
              )}
            </div>
          </div>
          <span className="spacer"></span>
          <div>
            <strong>{languageService("Description")}:</strong>
            <div style={{ border: "1px solid black", width: "100%", minHeight: "50px", padding: "10px" }}>
              <p>{issue.description}</p>
            </div>
          </div>
          <span className="spacer"></span>
          <div>
            <strong>{languageService("Photos of Observation:")}</strong>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
              <Row>
                {IssueImgList && (
                  <Col md="12">
                    <ImageArea
                      path="applicationresources"
                      imagesList={IssueImgList}
                      imageHeight={"380px"}
                      extraStyle={{ whiteSpace: "normal" }}
                    />
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </div>
        <ExecutionReport maintenanceDetails={maintenanceDetails} m1={m1} isLinear={isLinear} includeBridgeFields={includeBridgeFields} />
      </div>
    );
  }
}

const Methods = {
  getMPS: (m, m1) => {
    let startMarker = getIssueMPMethods.getIssueMarkerStart(m1.issue);
    let endMarker = getIssueMPMethods.getIssueMarkerEnd(m1.issue);
    let mExecMPStartPrefix = LocPrefixService.getPrefixMp(m.startMp, m1.lineId);
    let mExecMPEndPrefix = LocPrefixService.getPrefixMp(m.endMp, m1.lineId);
    let startMp = m.startMp
      ? `${mExecMPStartPrefix} ${m.startMp}`
      : startMarker || endMarker
        ? startMarker || "N/A"
        : getIssueMPMethods.getIssueFinalStartMP(m1.issue, m1.lineId, true);
    let endMp = m.endMp
      ? `${mExecMPEndPrefix} ${m.endMp}`
      : startMarker || endMarker
        ? endMarker || "N/A"
        : getIssueMPMethods.getIssueFinalEndMP(m1.issue, m1.lineId, true);
    return { startMp, endMp };
  },
  getCloseDate: (jplans) => {
    let date = "";
    Array.isArray(jplans) &&
      jplans.forEach((JP) => {
        let maintenanceEndDateTime =
          JP.tasks && JP.tasks[0] && JP.tasks[0].maintenance && JP.tasks[0].maintenance[0].endDateTime
            ? JP.tasks[0].maintenance[0].endDateTime
            : "";
        if (!date) date = maintenanceEndDateTime;
      });
    return date ? Methods.convertDateToFormat(date) : "";
  },
  convertDateToFormat: (dt) => {
    return new Date(dt).toLocaleDateString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetailPage/DetailViews/ExecutionDetail/WorkOrderReport/WorkOrderReport.jsx